import { createLink } from '@tanstack/react-router';
import MenuItem, { type MenuItemProps } from '@mui/material/MenuItem';
import { forwardRef } from 'react';

// see example: https://tanstack.com/router/latest/docs/how-to/integrate-material-ui
export const RouterMenuItem = createLink(
  forwardRef<HTMLAnchorElement, MenuItemProps>(({ sx, ...props }, ref) => {
    return (
      <MenuItem
        ref={ref}
        component="a"
        sx={[
          {
            borderLeft: '3px solid transparent',
            '&[data-status="active"]': {
              borderLeftColor: 'primary.main',
              bgcolor: 'action.selected',
            },
          },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...props}
      />
    )
  }),
)
